import React, { FC } from 'react';
import classNames from 'classnames';
import { Image, Popup } from '@whitesharx/starfall-frontend-ui-kit';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { ActPhrase, ActSticker, Emoji, PhrasePackName, PhraseType } from '../../../types';
import { containerStyles, contentStyles, imageStyles, phraseStyles } from './styles.css';
import { getProductName } from '../../../utils/game';
import Phrase from '../../Product/Phrase';

type EmojiPopupProps = {
  data: Emoji;
  isPlayer?: boolean;
  className?: string;
  isDesktop: boolean;
};

const EmojiPopup: FC<EmojiPopupProps> = ({ data, isPlayer, className, isDesktop }) => {
  const renderSticker = ({ sticker }: ActSticker) => {
    const [packId, stickerId] = getProductName(sticker?.id!).split('.');
    return (
      <Image
        src={`assets/images/shop/emoticons/${packId}/emoji.set${packId.match(/\d+/g)?.[0]}.${stickerId}.webp`}
        className={imageStyles}
      />
    );
  };

  const renderPhrase = ({ packId, id }: ActPhrase) => {
    const packName = getProductName(packId) as PhrasePackName;
    return (
      <Phrase packName={packName} className={phraseStyles} size="medium">
        {t(`phrases.${packName}.item${id as PhraseType['id']}`)}
      </Phrase>
    );
  };

  const getArrowPlacement = () => {
    if (isDesktop) {
      return isPlayer ? 'bottom' : 'top';
    }
    return isPlayer ? 'bottomRight' : 'topLeft';
  };

  return (
    <Popup
      className={classNames(containerStyles, className)}
      arrowPlacement={getArrowPlacement()}
      background="primary"
      content={
        <div className={contentStyles}>
          {data.type === 'phrase' ? renderPhrase(data as ActPhrase) : renderSticker(data as ActSticker)}
        </div>
      }
    />
  );
};

export default EmojiPopup;
